import React from 'react';
import { ReactNode } from 'react';
import { LinkSection } from '../LinkSection/LinkSection';
import { PracticeSection } from '../PracticeSection/PracticeSection';
import { View } from './Footer.styles';

interface FooterProps {
  practiceSection?: ReactNode;
  linkSection?: ReactNode;
}

export const Footer = React.memo(
  ({ practiceSection = <PracticeSection />, linkSection = <LinkSection /> }: FooterProps) => (
    <View>
      {practiceSection}
      {linkSection}
    </View>
  ),
);
